module.exports = __webpack_public_path__ + "static/img/zgbq.068c220.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zgbq.png
// module id = d6Wr
// module chunks = 0